import {Fragment, useContext, useRef, useState, useEffect} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {ReviewContext} from "../../context/ReviewContext";
import {APIPostOrderReview} from "../../api/orders/OrdersReviews";
import { UserContext } from '../../context/UserContext';
import {TfiClose} from "react-icons/tfi";

export default function ReviewCreate() {
    const {user} = useContext(UserContext);
    const {id,review, setReview, openReviewCreate, setMap, setOpenReviewCreate, currentPoint, setCurrentPoint} = useContext(ReviewContext);
    const cancelButtonRef = useRef(null);
    const [newReview, setNewReview] = useState({});

    const handelChanges = (e) => {
        const updatedReview = { ...newReview };

        if(typeof updatedReview[currentPoint?.id] === "undefined") {
            updatedReview[currentPoint?.id] = {};
            updatedReview[currentPoint?.id]["newCreation"] = true;
            updatedReview[currentPoint?.id]["id"] = currentPoint?.id;
            updatedReview[currentPoint?.id]["location"] = currentPoint?.location;
            updatedReview[currentPoint?.id]["type"] = "question";
            updatedReview[currentPoint?.id][e.target.name] = e.target.value;
        } else {
            updatedReview[currentPoint?.id][e.target.name] = e.target.value;
        }

        setNewReview(updatedReview);
    }

    const save = async () => {
        if (newReview?.[currentPoint?.id]?.name === "" || newReview?.[currentPoint?.id]?.message === "" || !newReview?.[currentPoint?.id]?.message || !newReview?.[currentPoint?.id]?.name) {
            return;
        }
        await APIPostOrderReview(id, newReview[currentPoint?.id], user)
        setReview(newReview);
        setMap(null);
        setCurrentPoint(null);
        setOpenReviewCreate(false);
    }

    const handleClose = () => {
        setNewReview(review);
        setCurrentPoint(null);
        setOpenReviewCreate(false);
    }

    useEffect(() => {
        setNewReview(review);
    }, [review]);

    return (
        <Transition.Root show={openReviewCreate} as={Fragment}>
            <Dialog
            className="relative z-10"
            initialFocus={cancelButtonRef}
            onClose={handleClose}
            >
            <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
    
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex h-full items-center justify-center sm:px-4 sm:pb-4 text-center pt-[65px] sm:px-4 lg:p-10 max-w-5xl mx-auto">
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <Dialog.Panel className='flex flex-col max-h-full sm:max-h-max h-full md:h-auto rounded-lg bg-white text-left shadow-xl transition-all w-full relative'>
                    <button
                        type='button'
                        className='absolute z-40 lg: lg:-top-6 lg:-right-6 top-2 right-2'
                        onClick={handleClose}
                        ref={cancelButtonRef}
                    >
                        <TfiClose className={"lg:size-16 border-gray-500/80 border-2 bg-white hover:bg-gray-300 lg:p-4 size-12 p-2 lg:rounded-full rounded-md"}/>
                    </button>
    
    
                    <div className='block md:flex w-full h-full '>
                        <div className=' rounded-tl-lg rounded-bl-lg py-8 px-8 md:flex w-full md:w-2/5 bg-gray-900 flex-col'>
                        <div>
                            <div className='flex items-center  mb-8 gap-2'>
                            <Dialog.Title
                                as='h3'
                                className='font-bold text-2xl leading-6 text-white'>
                                Eintrag erfassen
                            </Dialog.Title>
                            </div>
                        </div>
    
                        <div className={'h-auto md:h-[450px] '}>
                            <div className='h-full w-full pt-4 pb-8 '>
                                <div className='relative flex flex-col items-start pl-[0px] justify-between text-white/70 h-full'>
                                    Teilen Sie Ihrem Auftragnehmer Fehler, Änderungen, Fragen oder Anmerkungen im Rahmen der Abnahme mit.<br/><br/>
                                    XPlanung24 wird Ihren Auftragnehmer automatisch über Ihren Eintrag informieren, nachdem Sie die Abgabe abgelehnt haben.

                                </div>
                            </div>
                        </div>
                        </div>
                        <div className={'md:w-3/5 flex bg-white flex-col w-full'}>
                        <div className='p-8 flex flex-col flex-1  overflow-y-auto'>
                            <div className=" w-full">
                                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                    Art
                                </label>
                                <div className="mt-2">
                                    <select
                                        id="type"
                                        name="type"
                                        value={(typeof newReview?.[currentPoint?.id]?.type !== "undefined" ? newReview?.[currentPoint?.id]?.type : "")}
                                        onChange={(e) => handelChanges(e)}
                                        className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-500 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    >
                                        <option value={"question"}>Frage</option>
                                        <option value={"error"}>Fehler</option>
                                        <option value={"reminder"}>Erinnerung</option>
                                        <option value={"request"}>Korrekturwunsch</option>
                                        <option value={"additional"}>Änderung</option>
                                    </select>
                                </div>
                            </div>

                            <div className=" w-full  mt-4">
                                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                    Titel
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="name"
                                        name="name"
                                        type="text"
                                        placeholder={"Titel"}
                                        value={(typeof newReview?.[currentPoint?.id]?.name !== "undefined" ? newReview?.[currentPoint?.id]?.name : "")}
                                        onChange={(e) => handelChanges(e)}
                                        className="block w-full rounded-md border-0 p-2  text-gray-900 shadow-sm ring-1 ring-inset ring-gray-500 placeholder:text-gray-900 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    />
                                </div>
                            </div>

                            <div className="w-full mt-4">
                                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                    Beschreibung
                                </label>
                                <div className="mt-2">
                                    <textarea
                                        id="message"
                                        name="message"
                                        rows={3}
                                        placeholder={"Beschreibung"}
                                        value={(typeof newReview?.[currentPoint?.id]?.message !== "undefined" ? newReview?.[currentPoint?.id]?.message : "")}
                                        onChange={(e) => handelChanges(e)}
                                        className="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-500 placeholder:text-gray-600 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="p-8 sm:flex-row-reverse flex w-full flex-col-reverse gap-4">
                            <button
                                type="button"
                                className={`disabled:cursor-default cursor-pointer text-center truncate items-center rounded-md bg-white border-gray-900 border-2 disabled:text-gray-600/40 disabled:border-gray-500 px-4 py-3 text-sm font-semibold text-gray-900 `}
                                onClick={save}
                                disabled={newReview?.[currentPoint?.id]?.name === "" || newReview?.[currentPoint?.id]?.message === "" || !newReview?.[currentPoint?.id]?.message || !newReview?.[currentPoint?.id]?.name}
                            >
                            Speichern
                            </button>
                        </div>
                        </div>
                    </div>
                    </Dialog.Panel>
    
                </Transition.Child>
                </div>
            </div>
            </Dialog>
        </Transition.Root>
    )
}
